export const MAX_ASK_WHY_QUESTIONS = 3;

export const TOKEN_REGEX = /{{\s*prompt\.([a-zA-Z0-9_]+)\s*}}/g;
